import { textFormatting } from '@yola/ws-sdk';
import constants from '../constants';

const { AI_REWRITE_TEXT_MIN_SYMBOLS_LENGTH } = constants.common;

const isAiRewriteTextAllowed = () => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  return selection.toString().length > AI_REWRITE_TEXT_MIN_SYMBOLS_LENGTH;
};

export default isAiRewriteTextAllowed;
